import { useSelector } from "react-redux";
import { Config } from "../../../config";

export const DataRooms = () => {
  const { client_id, client_secret } = useSelector(
    (state) => state.clientSecrets
  );
  // URLs for Data Rooms
  const stagingUrl =
    "https://diligent-questionnaire-frontend.stag.hypercomply.com/organization/datarooms";
  const productionUrl =
    "https://diligent.hypercomply.com/organization/datarooms";

  // Determine environment (same logic as api-config.js)
  const isProduction = Config.apiGateway.URL?.includes(
    "diligent.hypercomply.com"
  );
  const dataRoomsUrl = isProduction ? productionUrl : stagingUrl;

  const handleViewClick = () => {
    window.open(`${Config.apiGateway.HC_URL}/organization/datarooms`, "_blank");
  };

  return (
    <div className="w-full ">
      <div className="flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-md border border-indigo-100 w-full max-w-sm text-center p-6">
          <div className="flex flex-col items-center space-y-4">
            {/* Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 text-indigo-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 8h10M7 12h6m-6 4h8m1 4v-4a2 2 0 012-2h3a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2h3a2 2 0 012 2v4"
              />
            </svg>
            {/* Heading */}
            <h2 className="text-xl font-semibold text-gray-800">
              View Data Rooms
            </h2>
            {/* Description */}
            <p className="text-sm text-gray-500">
              Please click this button to view the data rooms.
            </p>
            {/* Button */}
            <button
              onClick={handleViewClick}
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-sm px-6 py-2 rounded-md shadow-sm transition"
            >
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
